export enum dataToolsPaths {
  root = '/manage/data-tools',
  specific = '/manage/data-tools/:dataType',
}
